import script from "./NewsPageBodyPostBody.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageBodyPostBody.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageBodyPostBody.vue?vue&type=style&index=0&id=4b1305ca&scoped=true&lang=scss"
import "./NewsPageBodyPostBody.vue?vue&type=style&index=1&id=4b1305ca&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b1305ca"]])

export default __exports__